define('Handlebars.Helper', [
    'Handlebars',
    'Utils',
    'underscore'
], function HandlebarsHelper (
    Handlebars,
    Utils,
    _
) {

    'use strict';

    /* Handlebars helper to support absolute url
    * @params (String) image path
    * @params (String) default image path
    * @return (String) New constructed image path
    * */
    Handlebars.registerHelper('setImagePathWithDefault', function(imgPath, defaultImagePath) {
        if (imgPath && imgPath.indexOf('core/media') !== -1) {
            return imgPath.replace(Utils.getAbsoluteUrlOfNonManagedResources(''), '');
        }

        if(imgPath && imgPath === Utils.getAbsoluteUrlOfNonManagedResources(''))
        {
            imgPath = null;
        }
        return Utils.getThemeAbsoluteUrlOfNonManagedResources(defaultImagePath, imgPath);
    });
});
